
import { Component, Pipe, PipeTransform } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, App } from 'ionic-angular';
import { AppState } from '../../../app/app.global';


import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { THIRD_APP_JUMP,NEWS_SEARCH_BY_KEYWORD, SEARCH_MYALLAPPS_BY_KEYWORD, SEARCH_MYREMINDER, SEARCH_MYTODO } from '../../../providers/config/serviceurl';

import { NewsDetail } from '../../home/news/detail/detail';
import { SearchmorePage } from '../searchmore/searchmore';
import { MessagedetailPage } from '../messagedetail/messagedetail';
import {SingleSearchPage} from '../singlesearch/singlesearch';
import { Utils } from '../../../providers/service/utils';
import { InAppBrowser,InAppBrowserOptions  } from '@ionic-native/in-app-browser';
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage {
  user: any = {};
  resourceUrl:any;//资源url；

  //控制是否显示提示背景
  public isShowTipsBackgound = true;
  //控制搜索内容是否展示
  public isShowTitleBackgound = false;
  //关键词
  public searchKey: any;

  public newsAmount: any;
  //新闻列表
  public newsList: any = [];
  //服务列表
  public serviceList: any = [];
  //提醒消息列表
  public reminderMsgList: any = [];
  //提醒消息列表
  public myToDoMsgList: any = [];

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private httpService: HttpService, public global: AppState, private inAppBrowser:InAppBrowser,
    private alertCtrl: AlertController, public appCtrl: App) {
    this.user = StorageService.getObj('currentUser');
    this.resourceUrl = StorageService.getObj('resourceUrl');
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad CommonsearchPage');
  }

  //取消
  cancel() {
    this.navCtrl.pop();
  }

  //搜索
  search(e: any) {
    if (e.target.value == undefined || e.target.value == null || e.target.value == "") {
      this.isShowTipsBackgound = true;
      this.isShowTitleBackgound = false;
      return;
    } else {
      this.isShowTipsBackgound = false;
      this.isShowTitleBackgound = true;
    }
    //搜索框内容
    this.searchKey = e.target.value;
    //搜索新闻
    let params = { 'username': this.user.xgh, 'pageNo': 0, 'pageSize': 3, 'loadAll': false, 'keyword': e.target.value };
    this.httpService.get2(NEWS_SEARCH_BY_KEYWORD, params).then(anyObj => this.handleNewsList(anyObj));
    //搜索服务
    this.httpService.get2(SEARCH_MYALLAPPS_BY_KEYWORD, params).then(anyObj => this.handleServiceList(anyObj));
    //提醒搜索
    let remindParams = { 'username': this.user.xgh, 'pageNo': 0, 'pageSize': 3, 'code': '01', 'keyword': e.target.value };
    this.httpService.get2(SEARCH_MYREMINDER, remindParams).then(anyObj => this.handleReminderMsgList(anyObj));
    //待办搜索
    let toDoParams = { 'username': this.user.xgh, 'pageNo': 0, 'pageSize': 3, 'code': '02', 'keyword': e.target.value };
    this.httpService.get2(SEARCH_MYTODO, toDoParams).then(anyObj => this.handleMyToDoMsgList(anyObj));
  }
  handleNewsList(obj: any) {
    if (obj) {
     console.log(obj);
      // this.newsList = JSON.parse(obj);
      this.newsList = obj;
      // for (let index = 0; index < this.newsList.length; index++) {
      // 	if(this.newsList[index].releaseDate !=undefined && this.newsList[index].releaseDate != null && this.newsList[index].releaseDate != ""){
      // 		this.newsList[index].releaseDate = Utils.formateTimeGap((new Date(this.newsList[index].releaseDate)).getTime());
      // 	}

      // }
    }
  }
  handleServiceList(obj: any) {
    if (obj) {
      // console.log(JSON.parse(obj));
      this.serviceList = obj;
    }
  }
  handleReminderMsgList(obj: any) {
    if (obj) {
      // let returnData = JSON.parse(obj).items;
      // for (let index = 0; index < returnData.length; index++) {
      //   let str = returnData[index].content;
      //   let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
      //   let result;
      //   if ((result = regex.exec(str)) != null) {
      //     returnData[index].content = result[1];
      //   }
      // }
      // this.reminderMsgList.items = returnData;
      // this.reminderMsgList.totalItems = JSON.parse(obj).totalItems;
      let returnData = obj.items;
      for (let index = 0; index < returnData.length; index++) {
        let str = returnData[index].content;
        let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        let result;
        if ((result = regex.exec(str)) != null) {
          returnData[index].content = result[1];
        }
      }
      this.reminderMsgList.items = returnData;
      this.reminderMsgList.totalItems = obj.totalItems;
    }
  }

  handleMyToDoMsgList(obj: any) {
    if (obj) {
      // let returnData = JSON.parse(obj).items;
      // for (let index = 0; index < returnData.length; index++) {
      //   let str = returnData[index].content;
      //   let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
      //   let result;
      //   if ((result = regex.exec(str)) != null) {
      //     returnData[index].content = result[1];
      //   }
      // }
      // this.myToDoMsgList.items = returnData;
      // this.myToDoMsgList.totalItems = JSON.parse(obj).totalItems;
      let returnData = obj.items;
      for (let index = 0; index < returnData.length; index++) {
        let str = returnData[index].content;
        let regex = /<a.*?>(.*?)<\/a>/ig; //取a标签里面的内容
        let result;
        if ((result = regex.exec(str)) != null) {
          returnData[index].content = result[1];
        }
      }
      this.myToDoMsgList.items = returnData;
      this.myToDoMsgList.totalItems = obj.totalItems;
    }
  }

  //点击具体搜索内容
  gotoServe(event: any, item: any, flag: any) {
    item.flag = flag;
    if ('news' == flag) {
      this.appCtrl.getRootNav().push(NewsDetail, item);
    } else if ('service' == flag) {
      //逻辑处理暂且没有
      // let alert = this.alertCtrl.create({
      //   subTitle: '功能暂未开放',
      //   buttons: ['确定']
      // });
      // alert.present();
      // let colorTheme = this.global.colorTheme;
      // if (colorTheme != null && colorTheme != undefined && colorTheme.length > 4) {
      //   colorTheme = '#' + colorTheme.substring(5, colorTheme.length);
      // }
      // if (item != null && item != undefined) {
      //   let s = item.appUrl;
      //   if (s != null && s != undefined && s != '') {
      //     let o = JSON.parse(s);
      //     console.log(o.url[0].name + o.url[0].url);
      //     let title = o.url[0].name;
      //     let url = o.url[0].url;
      //     this.httpService.openOuterLink(title, url, colorTheme);
      //   }
      // }
      let colorTheme;
    console.dir(item);
    if(item != null && item != undefined){
      let o = item.SERVICE_APP_SUBSERVICE;
      if(o != null && o != undefined && o !=''){
         let title = o[0].SUBSERVICE_NAME;
         let url =  o[0].SERVICE_PROTOCOL_M+o[0].SERVICE_URL_M;
         let flag = "thirdApp";
         if(url.indexOf(flag) != -1){
          this.inAppBrowser.create(THIRD_APP_JUMP+"?hd="+this.user.hd+"&link="+this.urlencode(url),'_self','location=yes');
         }else{
        this.httpService.openOuterLink(title, url,colorTheme);
         }
      }
      }
    } else if ('reminderMsg' == flag) {
      this.appCtrl.getRootNav().push(MessagedetailPage, item);
    } else if ('myToDoMsg' == flag) {
      this.appCtrl.getRootNav().push(MessagedetailPage, item);
    }
  }

  urlencode (str) {  
    str = (str + '').toString();   
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').  
    replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');  
 } 

  singleSearch(type) {
    //console.log('查询内容===' + type)
    this.appCtrl.getRootNav().push(SingleSearchPage, { 'searchType': type });
  }

  //点击查看更多
  searchAllServiceByKeyword(flag: any) {
    this.appCtrl.getRootNav().push(SearchmorePage, { 'flag': flag, 'keyword': this.searchKey });
  }
}




// WEBPACK FOOTER //
// ./src/pages/commonsearch/search/search.ts